const URL_REGEXP = /^https?:\/\/[\w!?/+\-~:;.,=*&@#$%()'[\]]+$/;
const LOOSE_URL_REGEXP = /^https?:\/\/.+$/;

const testRegexp = (regexp: RegExp, value: string) => regexp.test(value);
const testUrl = (value: string, loose = false) => testRegexp(loose ? LOOSE_URL_REGEXP : URL_REGEXP, value);

export {
  testUrl,
};
